import { View, Log, Utils } from '../vendor/kerneljs';

const PanningMap = View.extend({

	enabled: true,

	interacting: false,
	animationSpeed: 800,
	panningOrigin: 'center',
	innerPositionOrigin: { x: 0, y: 0 },
	innerPositionNew: { x: 0, y: 0 },
	innerTransform: 'translate3d(0,0,0)',
	innerScale: 1,
	innerPreviousScale: null,
	transformOrigin: { x: 0, y: 0 },
	transformOriginStyles: '',
	maxScale: 2,
	imageSizeSet: false,
	savedWindowWidth: 0,
	events: {
		'click .map-marker': 'markerClickHandler',
		'click .js--mobile-activate': 'mobileActivateClickHandler',
		'click .js--mobile-deactivate': 'mobileDeactivateClickHandler'
	},

	initialize: function () {
		this.panningInner = this.find('.js--panning-map-inner');
		this.panningDraggable = this.find('.js--panning-map-draggable');
		this.panningInteractive = this.find('.js--panning-map-interactive');
		this.panningInteractiveMarkers = Utils.find(this.panningInteractive, '.map-marker'); //JPL: To ensure list, even when only 1 marker
		this.panningInteractiveLabels = Utils.find(this.panningInteractive, '.map-label');
		this.panningImage = this.find('.js--panning-map-image');

		this.mobileOverlay = this.find('.js--mobile-overlay');
		this.mobileDeactivate = this.find('.js--mobile-deactivate');


		this.eventEmitter.on('map:activate', this.focusMapOnMarker.bind(this));

		this.bodyRef = Utils.find('body')[0];

		this.touchMode = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0);

		if (this.touchMode) {
			Utils.on(this.panningInner, 'touchstart', this.touchStartHandler.bind(this));
			document.addEventListener('touchmove', this.touchMoveHandler.bind(this), { passive: false });
			Utils.on(document, 'touchend', this.touchEndHandler.bind(this));

			this.enabled = false;
		}
		else {
			Utils.on(this.panningInner, 'mousedown', this.mouseDownHandler.bind(this));
			Utils.on(document, 'mousemove', this.mouseMoveHandler.bind(this));
			Utils.on(document, 'mouseup', this.mouseUpHandler.bind(this));

			this.enabled = true;
		}

		setTimeout(function () {
			this.resetTransformOrigin();
			this.adjustInteractives();

			Utils.on(window, 'resize', this.resizeHandler.bind(this));
			this.resizeHandler();


			this.focusMarkers = Utils.find(this.panningInteractive, '.map-marker[data-center=true]');

			if (this.savedWindowWidth > 767) this.focusMapOnMarker();
		}.bind(this), 200);

	},

	focusMapOnMarker: function (event) {

		if (this.initialCenteringDone) return;

		try {
			if (this.focusMarkers.length > 1) {
				throw new Error('More than one data-center=true marker. Only 1 is allowed for each map. Marker count: ' + this.focusMarkers.length);
			}
			else {
				setTimeout(function () {
					this.initialCenteringDone = true;
					this.panToMarker(this.focusMarkers[0], true);
				}.bind(this), 20);
			}
		}
		catch (e) {
			Log.er('Can not focus on marker: ' + e);
		}
	},

	setImageSize: function () {
		if (this.imageSizeSet) return false;
		this.imageSizeSet = true;
		let imageStyles = 'width:' + this.panningImage.clientWidth + 'px; height:' + this.panningImage.clientHeight + 'px;';
		this.panningImage.setAttribute('style', this.panningImage.getAttribute('style') + imageStyles);
		this.resizeHandler();
	},

	resizeHandler: function () {
		let width = window.innerWidth;
		if (this.savedWindowWidth === width) return false;
		else {
			this.savedWindowWidth = width;
			this.mobileViewport = true;
			if (width > 768) {
				this.mobileViewport = false;
			}
			if (width >= 768) {
				this.enabled = true;
			}
			let CW = this.getCW(),
				CH = this.getCH(),
				DW = this.getDW(),
				DH = this.getDH();

			
			this.innerPositionNew.x = (CW - DW) * 0.34;
			this.innerPositionNew.y = (CH - DH) * 0.63;
			
			this.constrain();
			this.adjustInteractives();
		}
	},


	markerClickHandler: function (event) {
		let target = Utils.closestByClass(event.target, 'marker');
		if (Utils.hasClass(target, 'is-disabled')) return false;

		Utils.toggleClass(target, 'is-active');

		Utils.each(this.panningInteractiveMarkers, function (elem) {
			if (elem !== target) Utils.removeClass(elem, 'is-active');
		});

		this.interacting = false;
		this.fitMarker(target);
	},

	fitMarker: function (marker) {

		let markerDims = { w: 320, h: 200 },
			markerMargin = 5,
			CW = this.getCW(),
			CH = this.getCH(),
			CO = this.getCO(),
			DO = this.getDO(),
			MO = this.offset(marker);

		MO.left -= CO.left;
		MO.top -= CO.top;

		if (this.mobileViewport) {
			//center marker in viewport
			this.innerPositionNew.x = DO.left - (CO.left + MO.left - CW / 2 + markerDims.w / 2 - markerMargin);
			this.innerPositionNew.y = DO.top - (CO.top + MO.top - CH / 2 + markerDims.h / 2);
		}
		else {
			let position = marker.dataset.position,
				markerAdjustHorizontal = -markerDims.w,
				markerAdjustVertical = -markerDims.h;
			switch (position) {
				case 'bottom-right':
					markerAdjustHorizontal = markerDims.w;
					markerAdjustVertical = markerDims.h;
					break;
				case 'bottom-left':
					markerAdjustHorizontal = -markerDims.w;
					markerAdjustVertical = markerDims.h;
					break;
				case 'top-right':
					markerAdjustHorizontal = markerDims.w;
					markerAdjustVertical = -markerDims.h;
					break;
				case 'top-left':
					markerAdjustHorizontal = -markerDims.w;
					markerAdjustVertical = -markerDims.h;
					break;
				default:
					console.log("unexpected position:" + position)
			}

			if (this.panningOrigin.x >= CW + markerAdjustHorizontal) {
				this.innerPositionNew.x = DO.left - (CW + MO.left - markerAdjustHorizontal);
			}
			if (this.panningOrigin.y >= CH + markerAdjustVertical) {
				this.innerPositionNew.y = DO.top - (CH + MO.top - markerAdjustVertical);
			}
		}
		
		Utils.addClass(this.panningDraggable, 'is-animating');
		setTimeout(function () {
			Utils.removeClass(this.panningDraggable, 'is-animating');
		}.bind(this), 300);
		this.constrain();
	},

	panToMarker: function (marker, noAnimation) {
		let markerDims = { w: 60, h: 60 },
			CW = this.getCW(), //component width
			CH = this.getCH(), //component height
			DO = this.getDO(), //draggable offset
			MO = this.offset(marker); //marker offset

		this.innerPositionNew.x = DO.left - MO.left + CW / 2 - markerDims.w / 2;
		this.innerPositionNew.y = DO.top - MO.top + CH / 2 - markerDims.h / 2;

		if (!noAnimation) {
			Utils.addClass(this.panningDraggable, 'is-animating');
			setTimeout(function () {
				Utils.removeClass(this.panningDraggable, 'is-animating');
			}.bind(this), 300);
		}

		this.constrain();
	},


	mobileActivateClickHandler: function () {

		this.addClass('is-fixed');
		this.enabled = true;

		Utils.removeClass(this.mobileOverlay, 'is-active');
		if(this.mobileDeactivate && this.mobileDeactivate.length > 0) {
			this.mobileDeactivate.forEach(element => Utils.addClass(element, 'is-active'))
		} else {
			Utils.addClass(this.mobileDeactivate, 'is-active');
		}
		this.constrain();

		this.focusMapOnMarker();
	},

	mobileDeactivateClickHandler: function () {
		this.enabled = false;
		Utils.addClass(this.mobileOverlay, 'is-active');
		if(this.mobileDeactivate && this.mobileDeactivate.length > 0) {
			this.mobileDeactivate.forEach(element => Utils.removeClass(element, 'is-active'))
		} else {
			Utils.removeClass(this.mobileDeactivate, 'is-active');
		}
		this.removeClass('is-fixed');

		Utils.each(this.panningInteractiveMarkers, function (elem) {
			Utils.removeClass(elem, 'is-active');
		});
	},


	//TOUCH EVENTS
	touchStartHandler: function (event) {
		this.panningStart(event.targetTouches[0]);
	},
	touchMoveHandler: function (event) {
		if (!this.enabled) return false;
		if (!this.interacting) return false;

		event.preventDefault();
		event.stopImmediatePropagation();

		this.panningUpdate(event.targetTouches[0]);
	},
	touchEndHandler: function (event) {
		this.panningStop(event);
	},

	//MOUSE EVENTS
	mouseDownHandler: function (event) {
		this.panningStart(event);
	},
	mouseMoveHandler: function (event) {
		if (!this.enabled) return false;
		if (!this.interacting) return false;

		event.preventDefault();
		event.stopImmediatePropagation();

		this.panningUpdate(event);
	},
	mouseUpHandler: function (event) {
		this.panningStop(event);
	},



	panningStart: function (event) {

		if (!this.enabled) return false;

		let CO = this.getCO(),
			DO = this.getDO();
		this.panningOrigin = { y: event.pageY, x: event.pageX };
		this.innerPositionOrigin = { x: DO.left, y: DO.top };
		
		this.innerPositionOrigin.y -= CO.top;
		this.innerPositionOrigin.x -= CO.left;
		this.panningOrigin.y -= CO.top;
		this.panningOrigin.x -= CO.left;
		
		this.interacting = true;
	},

	panningUpdate: function (event) {
		let CO = this.getCO();
		this.innerPositionNew = { x: event.pageX + this.innerPositionOrigin.x + this.transformOrigin.x - this.panningOrigin.x - CO.left, y: event.pageY + this.innerPositionOrigin.y + this.transformOrigin.y - this.panningOrigin.y - CO.top };
		this.constrain();
	},

	panningStop: function () {
		if (!this.enabled) return false;

		this.interacting = false;
	},

	zoomHandler: function (event) {
		if (!this.enabled) return false;

		if (event.type === "doubletap") {
			if (this.innerScale === 1) {
				this.innerScale = 2;
			} else {
				this.innerScale = 1;
			}
			this.innerPreviousScale = this.innerScale;
		}
		if (event.type === "pinch") {
			this.innerScale = Math.max(.999, Math.min(this.innerPreviousScale * (event.scale), this.maxScale));
		}
		if (event.type === "pinchend") {
			this.innerPreviousScale = this.innerScale;
		}

		let touchPoint = event.changedPointers[0];

		let CO = this.getCO(),
			CW = this.getCW(),
			CH = this.getCH(),
			DW = this.getDW(),
			DH = this.getDH();

		this.transformOrigin = {
			x: DW * ((touchPoint.pageX - CO.left) / CW),
			y: DH * ((touchPoint.pageY - CO.top) / CH)
		};

		this.adjustInteractives();
		this.setDraggableStyles();
		setTimeout(this.constrain.bind(this), 400);
	},

	adjustInteractives: function () {
		let markerTransform = "scale3d(" + 1 / this.innerScale + ", " + 1 / this.innerScale + ", 1)";

		let style = "-webkit-transform: " + markerTransform +
			"; -ms-transform: " + markerTransform +
			"; -moz-transform: " + markerTransform +
			"; transform: " + markerTransform + ";"

		Utils.each(this.panningInteractiveMarkers, function (elem) {
			let elemData = elem.dataset;
			elem.setAttribute('style', style + elemData.positionstyle);

			Utils.removeClass(elem, 'map-marker--bottom-right');
			Utils.removeClass(elem, 'map-marker--bottom-left');
			Utils.removeClass(elem, 'map-marker--top-right');

			if (!this.mobileViewport) {
				if (elemData.positionx > 50) {
					if (elemData.positiony > 50) {
						//BOTTOM RIGHT
						elem.setAttribute('data-position', 'bottom-right');
						Utils.addClass(elem, 'map-marker--bottom-right');
					}
					else {
						//TOP RIGHT
						elem.setAttribute('data-position', 'top-right');
						Utils.addClass(elem, 'map-marker--top-right');
					}
				}
				else if (elemData.positiony > 50) {
					//BOTTOM LEFT
					elem.setAttribute('data-position', 'bottom-left');
					Utils.addClass(elem, 'map-marker--bottom-left');
				}
				else {
					elem.setAttribute('data-position', 'top-left');
					//TOP LEFT - default
				}
			}

			Utils.addClass(elem, 'is-ready');
		}.bind(this));

		Utils.each(this.panningInteractiveLabels, function (elem) {
			let elemData = elem.dataset;
			elem.setAttribute('style', style + elemData.positionstyle);
		});
	},

	constrain: function () {

		if (this.innerScale === 1) {
			this.resetTransformOrigin();
		}

		let CW = this.getCW(),
			CH = this.getCH(),
			DW = this.getDW(),
			DH = this.getDH();

		if (this.innerPositionNew.x < (CW - DW * this.innerScale) + this.transformOrigin.x) {
			this.innerPositionNew.x = (CW - DW * this.innerScale) + this.transformOrigin.x;
		}
		if (this.innerPositionNew.x > this.transformOrigin.x) {
			this.innerPositionNew.x = this.transformOrigin.x;
		}
		if (this.innerPositionNew.y < (CH - DH * this.innerScale) + this.transformOrigin.y) {
			this.innerPositionNew.y = (CH - DH * this.innerScale) + this.transformOrigin.y;
		}
		if (this.innerPositionNew.y > this.transformOrigin.y) {
			this.innerPositionNew.y = this.transformOrigin.y;
		}
		
		this.setDraggableStyles();
	},

	setDraggableStyles: function () {

		this.transformOriginStyles = "  -webkit-transform-origin: " + this.transformOrigin.x + "px " + this.transformOrigin.y + "px" +
			"; -ms-transform-origin: " + this.transformOrigin.x + "px " + this.transformOrigin.y + "px" +
			"; -moz-transform-origin: " + this.transformOrigin.x + "px " + this.transformOrigin.y + "px" +
			"; transform-origin: " + this.transformOrigin.x + "px " + this.transformOrigin.y + "px;"

		this.innerTransform = "translate3d(" + this.innerPositionNew.x + "px, " + this.innerPositionNew.y + "px, 0) " +
			"scale3d(" + this.innerScale + ", " + this.innerScale + ", 1)";

		let style = "-webkit-transform: " + this.innerTransform +
			"; -ms-transform: " + this.innerTransform +
			"; -moz-transform: " + this.innerTransform +
			"; transform: " + this.innerTransform + ";" + this.transformOriginStyles;

		this.panningDraggable.setAttribute('style', style);
	},

	resetTransformOrigin: function () {
		this.transformOrigin = { x: 0, y: 0 };
	},

	getCW: function () {
		return this.el.offsetWidth;
	},
	getCH: function () {
		return this.el.offsetHeight;
	},
	getDW: function () {
		return this.panningDraggable.offsetWidth;
	},
	getDH: function () {
		return this.panningDraggable.offsetHeight;
	},
	getCO: function () {
		return this.offset(this.el);
	},
	getDO: function () {
		return this.offset(this.panningDraggable);
	},
	offset: function (elem) {

		let docElem, win,
			box = { top: 0, left: 0, bottom: 0, right: 0 },
			doc = elem?.ownerDocument;

		if (!doc) {
			return {}
		}

		docElem = doc.documentElement;

		if (!docElem) {
			return {}
		}

		if (typeof elem.getBoundingClientRect !== typeof undefined) {
			box = elem.getBoundingClientRect();
		}
		win = (doc && doc === doc.window) ? doc : doc.nodeType === 9 && doc.defaultView;
		return {
			top: box.top + win.pageYOffset - docElem.clientTop,
			left: box.left + win.pageXOffset - docElem.clientLeft,
			right: box.right + win.pageXOffset - docElem.clientLeft,
			bottom: box.bottom + win.pageYOffset - docElem.clientTop
		};
	},


	tweenTo: function (el, prop, to, duration, easing, overwrite) {

		if (!el._mTween) { el._mTween = { top: {}, left: {} }; }
		let startTime = _getTime(), _delay, progress = 0, from = el.offsetTop, elStyle = el.style, _request, tobj = el._mTween[prop];
		if (prop === "left") { from = el.offsetLeft; }
		let diff = to - from;
		if (overwrite !== "none") { _cancelTween(); }
		_startTween();


		function _step() {
			progress = _getTime() - startTime;
			_tween();
			if (progress >= tobj.time) {
				tobj.time = (progress > tobj.time) ? progress + _delay - (progress - tobj.time) : progress + _delay - 1;
				if (tobj.time < progress + 1) { tobj.time = progress + 1; }
			}
			if (tobj.time < duration) { tobj.id = _request(_step); }
		}
		function _tween() {
			if (duration > 0) {
				tobj.currVal = _ease(tobj.time, from, diff, duration);
				elStyle[prop] = Math.round(tobj.currVal) + "px";
			} else {
				elStyle[prop] = to + "px";
			}
		}
		function _startTween() {
			_delay = 1000 / 60;
			tobj.time = progress + _delay;
			_request = (!window.requestAnimationFrame) ? function (f) { _tween(); return setTimeout(f, 0.01); } : window.requestAnimationFrame;
			tobj.id = _request(_step);
		}
		function _cancelTween() {
			if (!tobj.id ) { return; }
			if (!window.requestAnimationFrame) {
				clearTimeout(tobj.id);
			} else { window.cancelAnimationFrame(tobj.id); }
			tobj.id = null;
		}
		function _ease(t, b, c, d) {
			t /= d;
			let ts = t * t, tc = ts * t;
			return b + c * (0.499999999999997 * tc * ts + -2.5 * ts * ts + 5.5 * tc + -6.5 * ts + 4 * t);
		}
		function _getTime() {
			if (window.performance?.now) {
				return window.performance.now();
			}
			if (window.performance?.webkitNow) {
				return window.performance.webkitNow();
			} else if(Date.now) {
				return Date.now(); 
			} else { return new Date().getTime(); }
		}
	}
});

(function () {

	Utils.each(Utils.find('.js--panning-map'), function (elem) {
		new PanningMap({ el: elem });
	});

})();

export default PanningMap;
